const DesertsMass=[
    // {
    //     id:5,
    //     title:"сирники 240г/60г",
    //     price:"??? грн",
    //     src: require('../img/sirniki.png'),
    //     text:"творог, яйця, цукор",
    // },
    // {
    //     id:1,
    //     title:"торт шоколадно-помаранчевий 100г",
    //     price:"119 грн",
    //     src: require('../img/tort.webp'),
    //     text:"",
    // },
    // {
    //     id:2,
    //     title:"Фірмовий чізкейк Оранж 150г",
    //     price:"144 грн",
    //     src: require('../img/chizcake.png'),
    //     text:"",
    // },
    // {
    //     id:3,
    //     title:"вафлі з фруктами та морозивом 280г",
    //     price:"145 грн",
    //     src: require('../img/vaflizfrut.png'),
    //     text:"вафлі, банан, вишня мараскинова, виноград, морозіво пломбір, топінг на вибір(шоколад, малина, карамель), пудра",
    // },
    {
        id:4,
        title:"морозиво 100г",
        price:"94 грн",
        src: require('../img/icee.webp'),
        text:"пломбір, полуничне, шоколадне",
    allergy: `🥛 молоко, 🍫 какао`
    },
    
    
]

export default DesertsMass;